// extracted by mini-css-extract-plugin
export default {"form-wrapper":"ModalButtonEditor_form-wrapper__7WJwe","input-wrapper":"ModalButtonEditor_input-wrapper__jOXdY","select-wrapper":"ModalButtonEditor_select-wrapper__OrbKS"};